import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'react-materialize';
import * as actions from '../../actions';

class QueriesFiveWToggle extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.queryKeywordCheck !== this.props.queryKeywordCheck;
  }

  componentWillReceiveProps(nextProps) {
    const { positionFilter } = this.props;
    const { queryKeywordCheck } = nextProps;

    if (queryKeywordCheck === this.props.queryKeywordCheck) return;
    if (this.props.selectedPage !== nextProps.selectedPage) return;
    if (positionFilter !== nextProps.positionFilter) return;
  }

  componentDidMount() {
    const { $ } = window;
    const { toggleQueriesFiveW } = this.props;
    $('select.query-keyword-select').on('change', function() {
      const selectedW = $(this)[0].value;
      toggleQueriesFiveW(selectedW);
    });
  }

  render() {
    return (
      <div style={{ height: 37, marginTop: 5 }}>
        <div className="input-field" style={{ height: 'inherit' }}>
          <select className="query-keyword-select">
            <option value="false">Off</option>
            <option value="all">All query keywords</option>
            <option value="who">Who</option>
            <option value="what">What</option>
            <option value="where">Where</option>
            <option value="why">Why</option>
            <option value="how">How</option>
            <option value="is">Is</option>
            <option value="can">Can</option>
            <option value="does">Does</option>
          </select>
          <label>Query keywords</label>
          <span
            className="tooltipped position-tooltip"
            style={{
              top: -59,
              left: 90,
              position: 'relative'
            }}
            data-position="top"
            data-delay="50"
            data-tooltip="Filter keywords for questions"
          >
            <Icon tiny>info_outline</Icon>
          </span>
        </div>
      </div>
    );
  }
}

function mapStateToProps({
  selectedPage,
  startDate,
  endDate,
  country,
  positionFilter,
  queryKeywordCheck
}) {
  return {
    selectedPage,
    startDate,
    endDate,
    country,
    positionFilter,
    queryKeywordCheck
  };
}

export default connect(mapStateToProps, actions)(QueriesFiveWToggle);



// WEBPACK FOOTER //
// ./src/components/Dashboard/QueriesFiveWToggle.js